<template>
  <div :style="hostWrapperStyle">
    <DynamicComponentProduction
      v-if="cardDcId"
      :key="cardDcId"
      :dynamic-component-id="cardDcId"
      :is-production="renderingInProduction"
      :use-example-data="editMode"
      :theme-mode="themeMode"
    />
  </div>
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import ResumeStoryCardId from "%/dynamic-component-editor/options/resume-story-card-id";
import ResumeEmptyCardId from "%/dynamic-component-editor/options/resume-empty-card-id";
import DynamicComponentProduction
  from "%/dynamic-component-editor/components/DynamicComponentProductionComponent.vue";
import DcHostMixin from "%/dynamic-component-editor/mixins/dc-host-picker-mixin";
import { useReadStatusStore } from "%/dynamic-component-editor/stores/read-status-store";
import ReferencedComponentId from "%/dynamic-component-editor/options/referenced-component-id";
import ContextBindings from "%/dynamic-component-editor/options/context-bindings";

const FULLY_READ_PERCENT = 100;

export default {
  name: "ResumeCard",
  components: { DynamicComponentProduction },
  mixins: [DynamicElementMixin, DcHostMixin],
  inject: {
    pageEntities: { default: null },
    useExampleData: { default: () => () => false },
  },
  provide() {
    return {
      pageEntities: () => {
        const parent = typeof this.pageEntities === "function" ? this.pageEntities() : this.pageEntities;
        return { ...parent, story: this.resumeStoryId };
      },
    };
  },
  elementPanelSettings: {
    displayName: "Resume Component",
    displayIcon: "mdi:play-circle-outline",
    elementGroup: "storyElements",
    elementType: "element",
  },
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.layout-height": "hug",
      "default.layout-width": "hug",
    }),
  ],
  options: [
    ReferencedComponentId,
    ContextBindings,
    ResumeStoryCardId,
    ResumeEmptyCardId,
  ],
  computed: {
    isPreviewMode() {
      const fn = this.useExampleData;
      return typeof fn === "function" ? Boolean(fn()) : Boolean(fn);
    },
    resumeStoryId() {
      return useReadStatusStore().resumeStoryId;
    },
    resumeStoryPercent() {
      return useReadStatusStore().percentByStory[this.resumeStoryId] ?? 0;
    },
    hasStoryToResume() {
      if (this.editMode || this.isPreviewMode) {
        return true;
      }
      return this.resumeStoryId > 0 && this.resumeStoryPercent < FULLY_READ_PERCENT;
    },
    cardDcId() {
      if (!this.editMode && !this.isPreviewMode && !useReadStatusStore().resumeStoryLoaded) {
        return 0;
      }
      const cardId = this.hasStoryToResume
        ? this.getOptionValue(ResumeStoryCardId)
        : this.getOptionValue(ResumeEmptyCardId);
      return Number(cardId) || 0;
    },
  },
  created() {
    if (this.editMode || this.isPreviewMode) {
      return;
    }
    useReadStatusStore().loadResumeStory();
  },
};
</script>
